import { Validators } from "@angular/forms";
import { LayerType, sharedForms } from "../layer.model";
import { ColorOverlayProperties, FormType, HeightGlowProperties, Properties } from "../properties.model";

export const heightGlowForm: Properties = {
  propertyType: LayerType.HeightGlow,
  label: 'Height Glow Layer',
  forms:
    sharedForms.concat([
    {
      id: HeightGlowProperties.HeightGlowRange,
      label: 'Glow Range',
      type: FormType.RangeSlider,
      hint: "Control how far the glow extends",
      defaultValue: [0, 1],
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      },
    },
    {
      id: HeightGlowProperties.HeightGlowColor,
      label: 'Glow Color Gradient',
      type: FormType.Gradient,
      defaultValue: '#FF0000',
      validators: [Validators.required, Validators.min(1)],
    },
  ]),
  changeHandler: () => {}
}
